<template>
  <div class="new-order">

    <ReportsTabs
      :tabs="tabs"
      :warning="true"
      title="Отчет по заказам"
      :class="[
        {'tab--single': tabs.length === 1},
        {'tab--some': tabs.length === 2},
        'tab--new-order',
      ]">

      <ReportsOrdersFromDealers
        v-show="$route.query.tab === 'from_dealers'"
        :disabled="isDisabledEmployeeList"
      />

      <ReportsOrdersToSupplier
        v-show="$route.query.tab === 'to_supplier'"
        :disabled="isDisabledEmployeeList"
      />

      <ReportsOrdersRetail
        v-show="$route.query.tab === 'retail'"
        :disabled="isDisabledEmployeeList"
      />

    </ReportsTabs>

  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";

export default {
  name: "ReportsSelling",

  components: {
    ReportsTabs: () => import('@/pages/account/components/ReportsTabs'),
    ReportsOrdersFromDealers: () => import('./ReportsOrdersFromDealers'),
    ReportsOrdersToSupplier: () => import('./ReportsOrdersToSupplier'),
    ReportsOrdersRetail: () => import('./ReportsOrdersRetail'),
  },

  metaInfo() {
    return {
      title: `Отчет по заказам - Личный кабинет дилера - ${this.getDealerName}`,
    }
  },

  data: () => ({
    path: '',
    isDisabledEmployeeList: false,
    orderCount: {
      zgi: 0,
      cut: 0,
      opt: 0,
    },
    tabs: [
      {
        name: 'Заказы от дилеров',
        path: 'from_dealers'
      },
      {
        name: 'Заказы поставщику',
        path: 'to_supplier'
      },
      {
        name: 'Розничные заказы',
        path: 'retail'
      },
    ],
  }),

  computed: {
    ...mapGetters('user', [
      'getDealer',
      'getDealerName'
    ]),
    ...mapState({
      configAccess: state => state.user.configAccess,
    }),
  },

  methods: {
    ...mapActions('account', [
      'pullEmployees',
      'addEmptyEmployee',
    ]),

    ...mapActions('account/dealers', [
      'setDealers',
      'addEmptyDealer',
    ]),

    ...mapActions('account/orders', [
      'setStatusList',
      'addEmptyStatus',
    ]),

    orderCountUpdate(type, number) {
    },

    isReadOnlyPage() {
      const readonly = this.configAccess.reports.report_orders.main === 1;
      return readonly;
    },

    isNeedDisabled() {
      this.isDisabledEmployeeList = this.isReadOnlyPage()
      if (!this.isDisabledEmployeeList) {
        this.addEmptyEmployee()
      }
    },

    async fetchData() {
      await Promise.all([
        this.pullEmployees().then(res => {
          this.isNeedDisabled()
        }),
        this.setDealers(true).then(res => {
          this.addEmptyDealer();
        }),
        this.setStatusList().then(res => {
          this.addEmptyStatus();
        }),
      ]).then(res => {
        const query = this.$route.query.tab;
        const tabs = this.tabs.map(el => el.path);
        if (!tabs.includes(query)) {
          this.$router.push({
            query: {
              tab: this.tabs[0].path,
            }
          });
        }
      }).finally(() => {
        this.togglePreload(false);
      });
    },
  },

  beforeMount() {
    this.tabs = [
      {
        name: 'Розничные заказы',
        path: 'retail'
      },
    ]

    if (this.getDealer.parent_id) {
      this.tabs.unshift({
        name: 'Заказы поставщику',
        path: 'to_supplier'
      })
    }

    if (this.getDealer.has_sub_dealers) {
      this.tabs.unshift({
        name: 'Заказы от дилеров',
        path: 'from_dealers'
      })
    }
  },

  created() {
    this.togglePreload();
    this.fetchData();
  },

}
</script>

<style scoped lang="scss">
.new-order {
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
}
</style>
